import { render, staticRenderFns } from "./home-v1.vue?vue&type=template&id=675c00c0&scoped=true&"
import script from "./home-v1.vue?vue&type=script&lang=js&"
export * from "./home-v1.vue?vue&type=script&lang=js&"
import style0 from "./home-v1.vue?vue&type=style&index=0&id=675c00c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675c00c0",
  null
  
)

export default component.exports